module.exports = __webpack_public_path__ + "img/WOW Media Logo-01.be1ba119.png";